import { Box, Typography } from '@mui/material';

import {
  ClinicPayerConnectionsView,
  type ClinicPayerConnectionsViewProps,
} from './ClinicPayerConnectionsView';

type AdminPayerConnectionsViewProps = Omit<
  ClinicPayerConnectionsViewProps,
  'onStediLinkClick' | 'onFirstClaimLinkClick' | 'claimReviewNotice' | 'audience'
>;

const noop = () => undefined;

/** Clinic presentation; claim review stays explanatory until staff can open scoped claims. */
export function AdminPayerConnectionsView(props: AdminPayerConnectionsViewProps) {
  return (
    <Box
      component="section"
      aria-label="Payer connections"
      sx={{ p: { xs: 2, md: 3 }, bgcolor: 'background.paper' }}
    >
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Payer connections
      </Typography>
      <ClinicPayerConnectionsView
        {...props}
        audience="staff"
        onStediLinkClick={noop}
        onFirstClaimLinkClick={noop}
        claimReviewNotice="The clinic can review claims in JotBill."
      />
    </Box>
  );
}
